// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //apiUrl: 'http://back.test/api/v1/',
  //apiDoc: 'http://back.test/',
  apiUrl: 'https://api.reservarioblanco.co/api/v1/',
  apiDoc: 'https://api.reservarioblanco.co/',
  //apiUrl: 'http://127.0.0.1:8000/api/v1/',
  //apiDoc: 'http://127.0.0.1:8000/',
  language2: ''
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
